
import type { VAM2types } from "./VAMv2Types"; // type-only: breaks the MainCatalogTypes->VAMv2 ESM cycle edge

enum MainCatalogs_Classes {
    EvActivityStatus = "ev_activity_status",
    EvBookingStatus = "ev_booking_status",
    OMDutyType = "vt_duty_type",
    AbsenteeismType = "absenteeism_type",
    PresentType = "present_type",
    FunctionalGroup = "functional_group",
    FunctionalMainGroup = "functional_main_group",
    Venues = "venues",
    EvRoom = "ev_rooms",
    EvServices = "service_ev_serv",
    ServiceCategory = "service_categories_ev_serv",
    ServicePackage = "service_pack_ev_serv",
    ServiceChecklist = "service_checklist",
    HtServiceChecklistCategory = "ht_service_checklist_category",
    ServiceChecklistCategory = "service_checklist_category",
    ServicePackChecklist = "service_pack_checklist",
    EvCategory_1 = "ev_catagories_1",
    EvCategory_2 = "ev_catagories_2",
    AddressCategory = "address_categories",
    AddressMainCategory = "address_main_categories",
    FileCategory = "file_category",
    EvTaskDescript = "ev_task_descript",
    EvTaskDescriptGroup = "ev_task_grp",
    AudienceSeatingLayouts = "audience_seating_layouts",
    TodoPackage = "todo_package",
    TodoDescription = "todo_description",
    TodoCategory = "todo_category",
    TodoStatus = "todo_status",
    Professions = "ev_professions",
    Opus = "opus",
    PostalCodes = "postal_codes",
    WebToolTranslations = "webtool_translation",
    EvProjectType2 = "ev_project_types_2",
    EvProcessStatus = "ev_process_status",
    EvProcessGroupCategorie = "ev_process_group_categorie",
    EvProcessGroup = "event_process_group",
    PhysicalResources = "physical_resources",
    ProfessionalTitles = "professional_titles",
    AcademicTitlesPrefix = "academic_titles_prefix",
    AcademicTitlesSuffix = "academic_titles_suffix",
    JobTitle = "job_title",
    Composers = "persons",
    Performers = "performers",
    InternalInstrument = "internal_instrument",
    ExternalInstrument = "external_instrument",
    RelationGroups = "relation_groups",
    RelationTypes = "relation_types",
    SellingStatus = "ev_selling_status",
    ResourceMainGroup = "resource_main_group",
    ExtendedProperty = "vt_extended_property",
    DistributionChannel = "ev_distribution_channel"
}

enum OMDutyType_Classes {
    PresentType = "present_type",
    AbsentType = "absenteeism_type",
}

enum EvService_Types {
    "default" = 1,
    //"yesno" = 2,
    //"value" = 3,
    "text" = 4
}

enum ServiceChecklist_Types {
    "text" = 1,
    "yesno" = 2,
    "quantity" = 3,
    "time" = 4
}

enum YesNo_Values {
    "yes" = "Y",
    "no" = "N",
    "questionmark" = "?",
}

enum TodoDescriptionMode_Values {
    "out" = 0,
    "may complete" = 1,
    "may not complete" = 2,
}

enum MainCatalogs_ExternalEvents {
    Save = "external_save",
    Rollback = "external_rollback",
    Delete = "external_delete"
}

export {
    MainCatalogs_Classes,
    OMDutyType_Classes,
    EvService_Types,
    ServiceChecklist_Types,
    YesNo_Values,
    TodoDescriptionMode_Values,
    MainCatalogs_ExternalEvents
}

export namespace MainCatalogTypes {

    export interface MainCatalogs_Response<T> {
        entitylist: Array<T>,
        layouts: Array<StaticTable.Layout>;
    }

    export interface PhysicalResources_LoadData extends more.EntityAPIResultExtended {
        code: string,
        description: string,
        note: string,
        ref_resource_main_group: {
            ID: string,
            description: string
        },
        quantity: number,
        warning_quantity_level1: number,
        warning_percentage_level1: number,
        warning_quantity_level2: number,
        warning_percentage_level2: number,
        duration_forerun: number,
        duration_trailer: number,
        order: number,
        coloration: PIT_Coloration
    }

    export interface EvProjectType2_LoadData extends more.EntityAPIResultExtended {
        description: string,
        note: string,
        order: number,
        coloration: PIT_Coloration
    }

    export interface FileCategory_LoadData {
        ID: string,
        code: string,
        description: string,
        note: string,
        order: number,
        coloration: PIT_Coloration,
        is_active: boolean,
        ref_VtFileClass: {
            ID: string,
            Printname: string
        }
    }

    export interface AudienceSeatingLayoutsEditor_LoadData {
        ID: string,
        code: string,
        description: string,
        note: string,
        seating_capacity: number,
        is_default: boolean,
        ref_ev_room__ID: string;
        ref_ev_room__gDisp_1: string;
        existingFiles?: Array<VAM2types.VtFiles>;
        newFiles?: Array<any>;
        deletedFiles?: Array<any>;
    }
    export interface AudienceSeatingLayoutsEditor_SaveData extends AudienceSeatingLayoutsEditor_LoadData {
        is_new_status: boolean,
        ev_room_id: string
        is_to_delete: boolean,
        newFiles: Array<VAM2types.VtFiles>,
        deletedFiles: string[]
    }

    export interface FileCategory_SaveData {
        ID: string,
        is_new_status: boolean,
        code: string,
        description: string,
        note: string,
        order: number,
        coloration: PIT_Coloration,
        is_active: boolean,
        vtFileClass_id: string
    }

    export interface ServicePackage_LoadData {
        ID: string,
        description: string,
        note: string,
        //ref_service_pack_group: {
        //    ID: string,
        //    description: string
        //},
        evServices: Array<any>
    }

    export interface ServicePackage_SaveData {
        ID: string,
        is_new_status: boolean,
        description: string,
        note: string,
        //service_pack_group_id: string,
        evServices: Array<any>
    }

    export interface ServicePackChecklist_SaveData {
        ID: string,
        is_new_status: boolean,
        description: string,
        note: string,
        //service_pack_group_id: string,
        ServicesChecklist: Array<ServiceServicePackChecklist>
    }

    export interface ServiceServicePackChecklist extends more.EntityAPIResultExtended {
        ev_service_text_booking: string,
        ref_service_checklist: ServiceChecklist,
        ref_service_pack_checklist: ServicePackChecklist_SaveData,
        is_new: boolean,
    }

    export interface ServiceChecklistCategory extends more.EntityAPIResultExtended {
        is_new_status: boolean,
        order: number,
    }
    export interface HtServiceChecklistCategory extends more.EntityAPIResultExtended {
        ref_service_checklist: ServiceChecklist,
        ref_service_checklist_category: ServiceChecklistCategory,
        is_main_service_category: boolean,
        is_new_status: boolean,
    }

    export interface ServiceChecklist extends more.EntityAPIResultExtended {
        //ID: string,
        //description: string
    }

    export interface AddressCategories_LoadData {
        ID: string,
        description: string,
        note: string,
        order: number,
        ref_address_main_category: {
            ID: string,
            description: string
        },
    }

    export interface AddressCategories_SaveData {
        ID: string,
        is_new_status: boolean,
        description: string,
        note: string,
        order: number,
        address_main_category_id: string
    }

    export interface AddressMainCategories_LoadData {
        ID: string,
        description: string,
        note: string,
        order: number,
        coloration: PIT_Coloration,
        is_accommodation: boolean
    }

    export interface AddressMainCategories_SaveData extends AddressMainCategories_LoadData {
        is_new_status: boolean,
    }

    export interface EvCategories_LoadData {
        ID: string,
        code: string,
        description: string,
        note: string,
        order: number,
        coloration: PIT_Coloration,
        __multilang: object
    }

    export interface EvCategories_SaveData extends EvCategories_LoadData {
        is_new_status: boolean,
    }

    export interface ServiceCategory_LoadData {
        ID: string,
        description: string,
        note: string,
        order: number,
        coloration: PIT_Coloration,
        is_ev_task_create: boolean,
        __multilang: object
    }

    export interface ServiceCategory_SaveData extends ServiceCategory_LoadData {
        is_new_status: boolean,
    }
    export interface EvRoomEntity_Short {
        ID: string;
        description: string;
        coloration: more.EntityAPIColor;
        ref_venue: {
            ID: string;
            description: string;
        },
        is_employment: boolean;
    }
    export interface EvRoom_LoadData extends EvRoomEntity_Short {
        code: string,
        order: number,
        ref_ev_room_type: {
            ID: string,
            description: string
        },
        note: string,
        is_with_public: boolean,
        //is_get_coloration_from_group: boolean,
        is_not_relevant_for_overlapping_bookings: boolean,
        evServices: Array<any>,
        audience_seating_layouts: Array<AudienceSeatingLayoutsEditor_LoadData>
    }

    export interface EvRoom_SaveData {
        ID: string,
        is_new_status: boolean,
        code: string,
        description: string,
        order: number,
        coloration: PIT_Coloration,
        venue_id: string,
        ev_room_type_id: string,
        note: string,
        is_with_public: boolean,
        //is_get_coloration_from_group: boolean,
        is_not_relevant_for_overlapping_bookings: boolean,
        evServices: Array<any>,
        audience_seating_layout_entries: Array<any>
    }
    export interface TodoPackage_LoadData extends more.EntityAPIResult {
        order: number,
        note: string,
        EL_ht_todo_description_package_todo_package?: Array<any>
        EL_todoDescriptions?: Array<any>
    }

    export interface TodoPackage_SaveData {
        ID: string,
        description: string,
        order: number,
        coloration: PIT_Coloration,
        note: string,
        todoAssignemnts: Array<any>
    }

    export interface Venue_HintboxAddressData {
        ID: string,
        gDisp_1: string,
        note: string,
        building: string,
        street: string,
        c_postal_code: string,
        c_city: string,
        ref_country: {
            ID: string,
            description: string,
        },
    }

    export interface Venue_LoadData {
        ID: string,
        code: string,
        description: string,
        order: number,
        coloration: PIT_Coloration,
        is_home_venue: boolean,
        ref_address: Venue_HintboxAddressData,
        ref_address_runner: Venue_HintboxAddressData,
    }

    export interface Venue_SaveData {
        ID: string,
        is_new_status: boolean,
        code: string,
        description: string,
        order: number,
        coloration: PIT_Coloration,
        is_home_venue: boolean,
        address_id: string,
        address_runner_id: string,
    }

    export interface FunctionalGroup_LoadData {
        ID: string,
        code: string,
        _displayname: string,
        description_D: string,
        order: number,
        coloration: PIT_Coloration,
        ref_functional_main_group: {
            ID: string,
            description: string
        },
        number_of_lines: number,
        is_used_for_weekplaning: boolean,
        EL_functional_sub_group_functional_group: Array<FunctionalSubGroup_LoadData>
    }

    export interface FunctionalGroup_SaveData {
        ID: string,
        is_new_status: boolean,
        code: string,
        description: string,
        order: number,
        coloration: PIT_Coloration,
        functional_main_group_id: string,
        number_of_lines: number,
        is_used_for_weekplaning: boolean,
        functional_sub_group_list: Array<FunctionalSubGroup_SaveData>
    }

    export interface FunctionalSubGroup_LoadData {
        ID: string,
        code: string,
        _displayname: string;
        description: string,
        description_D: string,
        order: number,
        coloration: more.EntityAPIColor,
        __multilang: any
    }

    export interface FunctionalSubGroup_SaveData {
        ID: string,
        is_new_status: boolean,
        is_to_delete: boolean,
        code: string,
        description: string,
        order: number,
        coloration: PIT_Coloration,
        __multilang?: any
    }

    export interface FunctionalSubGroupV2_SaveData {
        ID: string,
        is_new_status: boolean,
        is_to_delete: boolean,
        code: string,
        description: string,
        order: number,
        coloration: more.EntityAPIColor
    }

    export interface FunctionalMainGroup_LoadData {
        ID: string,
        code: string,
        _displayname: string;
        description_D: string,
        order: number,
        coloration: PIT_Coloration
    }

    export interface FunctionalMainGroup_SaveData {
        ID: string,
        is_new_status: boolean,
        code: string,
        description: string,
        order: number,
        coloration: PIT_Coloration
    }

    export interface OMDutyType_LoadData {
        ID: string,
        Classname: string,
        _displayname: string;
        code: string,
        description_D: string,
        is_active: boolean,
        is_cancelled: boolean,
        is_present: boolean,
        percentage_count: number,
        percentage_free?: number,
        percentage_present?: number,
        order: number,
        coloration: PIT_Coloration
    }

    export interface OMDutyType_SaveData {
        ID: string,
        is_new_status: boolean,
        Classname: string,
        code: string,
        description: string,
        is_active: boolean,
        is_cancelled: boolean,
        is_present: boolean,
        percentage_count: number,
        percentage_free?: number,
        percentage_present?: number,
        order: number,
        coloration: PIT_Coloration
    }

    export interface BookingStatus_LoadData {
        ID: string,
        code: string,
        _displayname: string;
        description_D: string,
        is_active: boolean,
        is_definitive: boolean,
        is_cancelled: boolean,
        is_option: boolean,
        is_scheduler_definitive: boolean,
        is_generating_auto_cost_unit: boolean,
        is_import_to_commdoc: boolean,
        is_repository: boolean,
        is_not_relevant_for_overlapping_bookings: boolean,
        order: number,
        coloration: PIT_Coloration,
        __multilang: object
    }

    export interface BookingStatus_SaveData {
        ID: string,
        is_new_status: boolean,
        code: string,
        description: string,
        is_active: boolean,
        is_definitive: boolean,
        is_cancelled: boolean,
        is_option: boolean,
        is_scheduler_definitive: boolean,
        is_generating_auto_cost_unit: boolean,
        is_import_to_commdoc: boolean,
        is_repository: boolean,
        is_not_relevant_for_overlapping_bookings: boolean,
        order: number,
        coloration: PIT_Coloration,
        __multilang: object
    }


    export interface EvActivityStatus_LoadData {
        ID: string,
        code: string,
        _displayname: string;
        description_D: string,
        ref_ev_activity_status_group: {
            ID: string,
            description: string
        },
        //is_generating_auto_cost_unit: boolean,
        is_with_public: boolean,
        is_to_publish_in_web: boolean,
        //is_to_publish_in_ego: boolean,
        is_event: boolean,
        is_import_to_commdoc: boolean,
        //is_employment: boolean,
        order: number,
        coloration: PIT_Coloration,
        __multilang: object
    }

    export interface EvActivityStatus_SaveData {
        ID: string,
        is_new_status: boolean,
        code: string,
        description: string,
        ev_activity_status_group_id: string,
        //is_generating_auto_cost_unit: boolean,
        is_with_public: boolean,
        is_to_publish_in_web: boolean,
        //is_to_publish_in_ego: boolean,
        is_event: boolean,
        is_import_to_commdoc: boolean,
        //is_employment: boolean,
        order: number,
        coloration: PIT_Coloration,
        __multilang: object;
    }

    export interface EvService_EntityData {
        ID: string,
        is_new_entity: boolean,
        displayname: string,
        description_D: string,
        description_E: string,
        note: string,
        service_type: EvService_Types,
        is_external_usage: boolean,
        is_internal_usage: boolean,
        is_free_price_position: boolean,
        taskDescriptID: string,
        ref_service_unit: {
            ID: string,
            code: string,
            description: string
        }
        ev_service_text_external: string;
        ev_service_text_internal: string;
        ev_service_infotext: string,
        ev_service_text_booking: string,
        quantity_multiplier: number,
        quantity: number,
        categories: Array<any>;
        order: number,
        price_net: number,
        __multilang: object
        //priceGroups: number
    }

    export interface PIT_Coloration {
        //pitBGR: string,
        BackColor: PIT_Color,
        TextColor: PIT_Color,
    }

    export interface PIT_Coloration_Extended extends PIT_Coloration {
        pitBGR: string;
    }

    export interface PIT_Color {
        Hex: string,
        //IsNull: boolean,
        Red: number,
        Green: number,
        Blue: number
    }

    export interface EvTaskDescriptGroup_LoadData {
        ID: string,
        description: string,
        note: string,
        order: number,
        coloration: PIT_Coloration,
    }

    export interface EvTaskDescriptGroup_SaveData extends EvTaskDescriptGroup_LoadData {
        is_new_status: boolean,
    }

    export interface EvTaskDescript_LoadData {
        ID: string,
        Classname: string,
        _displayname: string;
        code: string,
        description_D: string,
        is_active: boolean,
        time_forerun: number,
        time_trailer?: number,
        order: number,
        ref_task_grp: {
            ID: string,
            description: string
        },
        addresses: Array<any>
    }

    export interface EvTaskDescriptAddress extends more.EntityAPIResultExtended {
        gDisp_1: string;
        addressID: string;
    }

    export interface EvTaskDescript_SaveData {
        ID: string,
        is_new_status: boolean,
        Classname: string,
        code: string,
        description: string,
        is_active: boolean,
        time_forerun: number,
        time_trailer?: number,
        order: number,
        ev_task_grp_id: string,
        addresses: Array<any>
    }

    export interface Address_SaveData {
        ID: string,
        is_new_status: boolean,
        is_to_delete: boolean,
        vt_address_backoffice_id: string
    }

    export interface Address_LoadData {
        ID: string,
        gDisp_1: string
    }

    export interface EvProfessions_LoadData {
        ID: string,
        Classname: string,
        ClassPrintname: string,
        _displayname: string,
        code: string,
        description: string,
        is_conductror: boolean,
        is_show_ev_professions: boolean,
        is_solo_instrument: boolean,
        order: number,
        ref_ev_profession_type: {
            ID: string,
            Classname: string,
            ClassPrintname: string,
            _displayname: string,
            description: string
        },
        ref_performer_display_mode: {
            ID: string,
            ClassName: string,
            ClassPrintname: string,
            _displayname: string,
            code: string,
            description: string
        },
        ref_ev_profession_groups: {
            ID: string,
            CLassName: string,
            ClassPrintname: string,
            _displayname: string,
            code: string,
            description: string,
            coloration: PIT_Coloration
        },
        __multilang: object
    }

    export interface EvProfessions_SaveData {
        ID: string,
        code: string,
        description: string,
        is_conductor: boolean,
        /*is_show_ev_professions: boolean,*/
        is_solo_instrument: boolean,
        order: number,
        ev_profession_type_id: string,
        performer_display_mode_id: string,
        ev_profession_groups_id: string,
        /*coloration: PIT_Coloration,*/
        is_new_status: boolean,
        __multilang: object
    }

    export interface Opus_LoadData extends VAM2types.VoiceAttributes {
        ID: string,
        Classname: string,
        ClassPrintname: string,
        $Displayname: string,
        gDisp_opus: string,
        gDisp_composer_author: string,
        opus_titel_D: string,
        opus_subtitel_D: string,
        opus_calling_name_D: string,
        opus_titel_original: string,
        opus_info_text_html: string,
        opus_info_text_html_E: string,
        duration_min: number,
        note: string,
        note_special: string,
        movements: string,
        opus_first_release: string,
        created_from: string,
        created_until: string,
        created_about: string,
        EL_ht_addresses_opus_opus: Array<RelatedAddress>,
        ModificationUser: string,
        ModificationDate: string,
    }

    export interface RelatedAddress {
        ID: string,
        Classname: string,
        ClassPrintname: string,
        ref_opus: Opus_LoadData,
        ref_address: {
            ID: string,
            Classname: string,
            ClassPrintname: string,
            gDisp_Firstname_Name: string
        },
        ref_relation_type: {
            ID: string,
            Classname: string,
            ClassPrintname: string,
            description: string
        },
        order: number;
    }

    export interface RelatedAddressTableEntry {
        ID: string,
        ref_opus: {
            ID: string,
            gDisp_opus: string
        }
        ref_address: {
            ID: string,
            gDisp_Firstname_Name: string,
        }
        ref_relation_type: {
            ID: string,
            description: string
        }
        order: number
    }

    export interface ProgramTableEntry {
        ID: string;
        Classname: string;
        ClassPrintname: string;
        $Displayname: string;
        note: string;
        duration_min: number;
        ref_ev_program_ev_project: {
            ID: string;
            Classname: string;
            ClassPrintname: string;
            $Displayname: string;
            gDisp_1: string;
        };
        ref_ev_booking: {
            ID: string;
            Classname: string;
            ClassPrintname: string;
            $Displayname: string;
            gDisp_1: string;
        };
        ref_ev_program_status: {
            ID: string;
            Classname: string;
            ClassPrintname: string;
            $Displayname: string;
            description: string;
        }
    }

    export interface NotesTableEntry extends more.EntityAPIResultExtended {
        description: string,
        c_conductor: string,
        ref_note_owner_status: {
            description: string;
        }
    }

    export interface Opus_SaveData extends VAM2types.VoiceAttributes {
        ID: string,
        opus_titel_D: string,
        opus_subtitel_D: string,
        opus_calling_name_D: string,
        opus_titel_original: string,
        opus_info_text_html: string,
        opus_info_text_html_E: string,
        duration_min: number,
        note: string,
        note_special: string,
        movements: string,
        opus_first_release: string,
        created_from: string,
        created_until: string,
        created_about: string,
        El_ht_addresses_opus_opus: Array<RelatedAddressTableEntry>
        EL_ht_addresses_opus_opus_diffData: EntityStoreData<RelatedAddressTableEntry>,
        is_new_status: boolean
    }

    export interface PostalCodes_LoadData extends more.EntityAPIResultExtended {
        city: string;
        postal_code: string;
        ref_country: RefCountry;
        ref_state: RefState;
        changedValues: any;
    }

    export interface WebTranslations_LoadData extends more.EntityAPIResultExtended {
        description: string;
        note: string;
        isMultiline: boolean;
        is_non_default: boolean;
        __multilang: object;
    }

    export interface RefCountry extends more.EntityAPIResultExtended {
        lc_iso_alpha_2: string;
    }

    export interface RefState extends more.EntityAPIResultExtended {
        description: string;
    }

    export interface EvProcess_LoadData extends more.EntityAPIResultExtended {
        ev_process_name: string;
        date_start: string;
        date_end: string;
        duration: number;
        duration_hours: number;
        duration_minutes: number;

    }

    export interface EvProcess_SaveData {
        ID: string;

    }

    //TODO BESCHREIBUNGEN
    export interface TodoDescription_TableEntry {
        assignmentID: string;
        isDeleted?: boolean;
    }
    export interface TodoDescription_RemindersTable_Entry extends TodoDescription_TableEntry {
        userID: string;
        gDisp_1: string;
    }
    export interface TodoDescription_RemindersData {
        ID: string;
        gDisp_1: string;
    }
    export interface TodoDescription_AssociateGroupsTable_Entry extends TodoDescription_TableEntry {
        groupID: string;
        description: string;
    }
    export interface TodoDescription_AssociateGroupsData {
        ID: string;
        description: string;
    }
    export interface TodoDescription_TodoTelecommunicationsTable_Entry extends TodoDescription_TableEntry {
        telecomID: string;
        telecom_code: string;
        telecom_address: string;
        description: string;
    }
    export interface TodoDescription_TodoTelecommunicationsData {
        ID: string;
        description: string;
        telecom_code: string;
        telecom_address: string;
    }
    export interface TodoDescription_TodoPackageTable_Entry extends TodoDescription_TableEntry {
        packageID: string;
        description: string;
    }
    export interface TodoDescription_TodoPackageData {
        ID: string;
        description: string;
    }
    export enum TodoDescription_SelectedEntriesListNames {
        reminders = "reminders",
        associateGroups = "associateGroups",
        todoTelecommunications = "todoTelecommunications",
        todoPackages = "todoPackages",
    }
}
